import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../auth.service';
import { ApiService } from '../api.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { BottomSheet } from '../bottom.sheet';
import { HandlerService } from '../handler.service';
import { Platform } from '@angular/cdk/platform';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl } from '@angular/forms';
import { ExcelService } from '../excel.service';
let k = 1, j = 90;
@Component({
  selector: 'app-vendor-subscriptions',
  templateUrl: './vendor-subscriptions.component.html',
  styleUrls: ['./vendor-subscriptions.component.scss'],
})
export class VendorSubscriptionsComponent {

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
  Cview: boolean = true;
  displayedColumns = ['id', 'custName', 'identificationNbr', 'make', 'model', 'place', 'region', 'service', 'payment1', 'payment2', 'payment3', 'status', 'getdetails'];
  dataSource: any;
  mbv: boolean;
  loader: boolean;
  active1: boolean = false;
  call: boolean = true;
  count;
  id;
  newItems;
  serviceFlat;
  serviceStreet;
  serviceRegion;
  serviceName;
  carmodel;
  value;
  carmake;
  payStatusName1;
  payStatusName2;
  payStatusName3;
  PayMonth1;
  PayMonth2;
  PayMonth3;
  reqStatusName;
  payStatusName;
  search: any = [];
  filterLength;
  minDate = new Date();
  items = [];
  serviceInc: boolean;
  customerPop: boolean;
  pName;
  pColor;
  paymentActivity;
  pMake;
  subsItems;
  pModel;
  dateFormat;
  pIdentity;
  confirm: boolean = false;
  cancelId;
  pDate;
  numb;
  cId;
  url;
  check: boolean = false;
  send: boolean = false;
  status;
  pageEnd: boolean = false;
  Paymentpop: boolean = false;
  payment = [{ id: undefined, name: "All" }, { id: 2, name: "Paid" }, { id: 1, name: "Not Paid" }]
  statusObj = [{ id: 1, name: "Pending" },
  { id: 9, name: "Assigned" },
  { id: 6, name: "Allocated" },
  { id: 4, name: "Cancelled" },
  { id: 0, name: "All" }]
  actionObj = [{ id: 0, name: "Schedule On Demand Service" },
  { id: 1, name: "Payment Remainder" }]
  actionName;
  actionId;
  allocationOptions: any = []
  statusName;
  statusId;
  subs;
  category;
  clicked: boolean;
  cateName = "CAR CARE SERVICES";
  cateId;
  cate1Id;
  buttonName = "Show YB Only";
  paymentName;
  filterItems;
  paymentId;
  allItems: any = [];
  notifyItems: any = [];
  nameCheck: boolean = false;
  fName;
  optionName;
  optionId;
  enddate;
  orgs;
  orgName;
  orgId;
  contractors;
  contractorId;
  ContractorName;
  filterPop: boolean = false;
  contDrop: boolean = false;
  customerPopSearch: boolean;
  searchShow: boolean = true;
  custName;
  response;
  cloneUsers: any = [];
  paymentDetails: any;
  monthObj: any = [{ id: 1, name: "JAN" },
  { id: 2, name: "FEB" },
  { id: 3, name: "MAR" },
  { id: 4, name: "APR" },
  { id: 5, name: "MAY" },
  { id: 6, name: "JUN" },
  { id: 7, name: "JUL" },
  { id: 8, name: "AUG" },
  { id: 9, name: "SEP" },
  { id: 10, name: "OCT" },
  { id: 11, name: "NOV" },
  { id: 12, name: "DEC" }];
  userData: any;
  userCheck: boolean;
  openPopUp: boolean = false;
  message: any;
  text: boolean;
  filter: boolean;
  cancellation;
  cancelledReasons;
  idFilter = new FormControl('');
  bikeNumberFilter = new FormControl('');
  paymentStatusFilter1 = new FormControl('');
  paymentStatusFilter2 = new FormControl('');
  paymentStatusFilter3 = new FormControl('');
  serviceNameFilter = new FormControl('');
  serviceRegionFilter = new FormControl('');
  serviceFlatFilter = new FormControl('');
  carmodelFilter = new FormControl('');
  carmakeFilter = new FormControl('');
  custNameFilter = new FormControl('');
  statusFilter = new FormControl('');
  filterValues = {
    id: '',
    bikeNumber: '',
    serviceFlat: '',
    regionId: '',
    serviceName: '',
    carmodel: '',
    serviceStreet: '',
    carmake: '',
    custName: '',
    payStatusName1: '',
    payStatusName2: '',
    payStatusName3: '',
    reqStatusName: ''

  };
  excelDataAll: any = [];
  excell: any = [];
  paymentDetail;
  identificationNo;
  Make;
  Model;
  Colour;
  payments;
  packName;
  Month1;
  Month2;
  Month3;
  closeing: boolean = false;
  maxLen;
  i;
  array = []
  constructor(public auth: AuthService, private router: Router, public handler: HandlerService,
    public service: ApiService, private bottomSheet: MatBottomSheet, private platform: Platform,
    private excelService: ExcelService) { }

  ionViewWillEnter() {
    sessionStorage.setItem('vendorApp', 'true');
    this.array = [];
    this.idFilter.valueChanges
      .subscribe(
        id => {
          this.filterValues.id = id;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.bikeNumberFilter.valueChanges
      .subscribe(
        bikeNumber => {
          this.filterValues.bikeNumber = bikeNumber;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.paymentStatusFilter1.valueChanges
      .subscribe(
        payStatusName1 => {
          this.filterValues.payStatusName1 = payStatusName1;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.paymentStatusFilter2.valueChanges
      .subscribe(
        payStatusName2 => {
          this.filterValues.payStatusName2 = payStatusName2;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.paymentStatusFilter3.valueChanges
      .subscribe(
        payStatusName3 => {
          this.filterValues.payStatusName3 = payStatusName3;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.statusFilter.valueChanges
      .subscribe(
        reqStatusName => {
          this.filterValues.reqStatusName = reqStatusName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.serviceNameFilter.valueChanges
      .subscribe(
        serviceName => {
          this.filterValues.serviceName = serviceName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.serviceRegionFilter.valueChanges
      .subscribe(
        regionId => {
          this.filterValues.regionId = regionId;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.serviceFlatFilter.valueChanges
      .subscribe(
        serviceFlat => {
          this.filterValues.serviceFlat = serviceFlat;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.carmodelFilter.valueChanges
      .subscribe(
        carmodel => {
          this.filterValues.carmodel = carmodel;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.carmakeFilter.valueChanges
      .subscribe(
        carmake => {
          this.filterValues.carmake = carmake;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.custNameFilter.valueChanges
      .subscribe(
        custName => {
          this.filterValues.custName = custName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.notifyItems = [];
    this.filter = false;
    this.dateFormat = this.auth.getDateformat();
    sessionStorage.removeItem('employee')
    sessionStorage.removeItem('vendor')
    this.loader = true;

    if (this.platform.ANDROID || this.platform.IOS) {
      this.text = true;
      this.mbv = false;
    } else {
      this.text = false;
      this.mbv = true;
    }
    this.cateId = 21;
    this.id = localStorage.getItem('organizationId')
    this.getCount();
    this.paymentName = "All";
    if (this.id == 790) {
      this.buttonName = "Show YB Only"
      k = 1;
      this.service.getCustItemSubsCate(this.cateId, k).subscribe((res: any) => {

        if (res) {
          this.loader = false;

          this.allItems = res;
          this.allItems.map(res2 => {
            Object.assign(res2, { pay: false })
          })
          this.items = res;
          this.items.map(res1 => {
            Object.assign(res1, { clicked: false, bikeNumber: res1.custItems[0]?.identificationNo })
          })
          this.items.map(dat => {
            if (dat.paymentDetails) {
              dat.paymentDetails.map(dat1 => {
                this.monthObj.map(dat2 => {
                  if (dat1.month == dat2.id) {
                    Object.assign(dat1, { monthName: dat2.name })
                  }
                })
              })
            }
          })
          this.filterItems = this.items;
          k++;
          this.getOrgs();
        } else {
          this.items = [];
          this.handler.res("No Data Found");
          this.getOrgs();
        }
      }, err => {
        this.loader = false;
        this.handler.err(err);
      })
    } else {
      k = 1;
      this.service.getVenCustItemSubsCate(this.id, this.cateId, k).subscribe((res: any) => {
        if (res) {
          this.loader = false;
          this.allItems = res;
          this.items = res;
          this.items.map(res => {
            Object.assign(res, { clicked: false })
          })
          this.items.map(res1 => {
            Object.assign(res1, { bikeNumber: res1.custItems[0]?.identificationNo })
          })
          this.filterItems = this.items;
          this.loader = false;
          k++;
        } else {
          this.items = [];
          this.handler.res("No Data Found");
          this.loader = false;
        }
      }, err => {
        this.loader = false;
        this.handler.err(err);
      })

    }
    this.getCategory();
    this.getCancelReason();

  }

  getCust(val) {
    let x = val.length;
    this.allItems = [];
    this.count = "";
    this.items = [];
    if (x > 0) {
      this.closeing = true;
      if (this.id == 790) {
        this.service.searchCustItemSubsCate(val).subscribe((res: any) => {
          // this.allItems=[];
          // this.count="";
          // this.items=[];   
          if (res != null && res != "NO_CONTENT" && res.length > 0) {
            this.loader = false;
            this.allItems = res;
            this.allItems.map(res2 => {
              Object.assign(res2, { pay: false })
            })
            this.allItems.map(res1 => {
              Object.assign(res1, { clicked: false, value: val })
            })
            this.allItems.map(dat => {
              if (dat.paymentDetails) {
                dat.paymentDetails.map(dat1 => {
                  this.monthObj.map(dat2 => {
                    if (dat1.month == dat2.id) {
                      Object.assign(dat1, { monthName: dat2.name })
                    }
                  })
                })
              }
            })
            this.allItems.map(res1 => {
              this.array.push(res1)
            })
            this.items = this.array.filter(res2 => { return res2.value == this.search });
            this.count = this.items.length;
            if (this.search == "" || this.search == undefined) {
              this.items = this.filterItems;
              this.count = this.items.length;
              this.closeing = false;
            }
          } else {
            this.items = [];
            this.handler.res("No Data Found");
          }
        }, err => {
          this.loader = false;
          this.handler.err(err);
        })

      } else {
        this.service.searchVenCustItemSubsCate(this.id, val).subscribe((res: any) => {
          this.allItems = [];
          this.count = "";
          this.items = [];
          if (res != null && res != "NO_CONTENT" && res.length > 0) {
            this.loader = false;
            this.allItems = res;
            this.allItems.map(res2 => {
              Object.assign(res2, { pay: false })
            })
            this.allItems.map(res1 => {
              Object.assign(res1, { clicked: false, bikeNumber: res1.custItems[0]?.identificationNo, value: val })
            })
            this.allItems.map(dat => {
              if (dat.paymentDetails) {
                dat.paymentDetails.map(dat1 => {
                  this.monthObj.map(dat2 => {
                    if (dat1.month == dat2.id) {
                      Object.assign(dat1, { monthName: dat2.name })
                    }
                  })
                })
              }
            })

            this.allItems.map(res1 => {
              this.array.push(res1)
            })
            this.items = this.array.filter(res2 => { return res2.value == this.search });
            this.count = this.items.length;
            if (this.search == "" || this.search == undefined) {
              this.items = this.filterItems;
              this.count = this.items.length;
              this.closeing = false;
            }
          } else {
            this.items = [];
            this.handler.res("No Data Found");
          }
        }, err => {
          this.loader = false;
          this.handler.err(err);
        })

      }
    }

  }

  getCount() {
    this.service.getSubscriptionCount(this.cateId).subscribe((res: any) => {
      this.count = res;
    })
  }

  assignVendor(data, id) {
    sessionStorage.setItem('catId', data.services[0].itemCategoryId)
    sessionStorage.setItem('employee', data.serviceContractorId)
    sessionStorage.setItem('vendor', data.vendorId)
    this.router.navigate(['/manageSubAssign/', +id]);
  }

  Vendorselect1(data, id) {
    sessionStorage.setItem('catId', data.services[0].itemCategoryId)
    this.router.navigate(['/packageAssign/', +id]);
    window['appointmentObj'] = data;

  }



  changeVendorselect1(data, id) {
    sessionStorage.setItem('catId', data.services[0].itemCategoryId)
    sessionStorage.setItem('vendor', data.vendorId)
    this.router.navigate(['/changePackageAssign/', +id]);
    window['appointmentObj'] = data;
  }

  openPop(data) {
    this.serviceInc = true
    this.pName = data.services[0].name;
    this.pColor = data.custItems[0].colour;
    this.pMake = data.custItems[0].make;
    this.pModel = data.custItems[0].model;
    this.pIdentity = data.custItems[0].identificationNo;
    var x = data.custItems[0].purchaseDate.split("T")
    this.pDate = x[0].split("-").reverse().join("-")
  }

  getId(data) {
    if (data.custItems) {
      if (data.custItems[0]) {
        return data.custItems[0]?.identificationNo
      }
    }
  }

  openBottomSheet() {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.category,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.cateName = res.name;
        this.cateId = res.id;
      }
    });
  }

  getCategory() {
    this.service.getOrgCategory().subscribe((res: any) => {
      this.category = res;
      this.getsc1()
    })
  }


  showActiveData() {
    this.loader = true;
    // var userId=localStorage.getItem('currentUserId'); 
    if (this.buttonName == "Show YB Only") {
      this.buttonName = "Show All"
      this.items = this.allItems.filter(res => { return res.vendorId == 790 });
      this.filterItems = this.items;
    } else {
      this.buttonName = "Show YB Only"
      this.items = this.allItems;
      this.filterItems = this.items;
    }

    setTimeout(() => {
      this.loader = false;
    }, 1000);
  }

  openBottomSheetstatus() {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.payment,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.paymentName = res.name;
        this.paymentId = res.id;
        if (this.paymentId) {
          this.allItems.map(res2 => {
            Object.assign(res2, { pay: false })
          })
          this.allItems.map(res1 => {
            if (res1.paymentDetails != []) {
              res1.paymentDetails.map(res2 => {
                if (this.paymentId == res2.paymentStatus) {
                  Object.assign(res1, { pay: true })
                }
              })
            }
          })
        } else {
          this.allItems.map(res2 => {
            Object.assign(res2, { pay: false })
          })
        }

      }
    })
  }

  getOrgs() {
    this.service.getOrg().subscribe((res: any) => {
      this.orgs = res;
      this.orgs.push({ id: 0, name: "All" })
    })
  }


  openBottomSheetOrg(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.orgs,
    });
    dialogRef.afterDismissed().subscribe((res: any) => {
      if (res) {
        // this.loader=true;
        this.orgName = res.name;
        this.orgId = res.id;
        this.contDrop = true;
        //  this.loader=false;
        this.getsc();

      }

    });
  }


  openBottomSheetCheck() {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.statusObj,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.statusName = res.name;
        this.statusId = res.id;

      }
    })


  }

  cancel(id) {
    this.cancelId = id;
    this.confirm = true;
  }

  returnDate(data) {
    let date = data.getDate();
    date = date < 10 ? '0' + date : date;
    let month = data.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let year = data.getFullYear();
    return year + '-' + month + '-' + date;
  }


  cancelPop() {
    this.confirm = false;
    this.cancelReq();
  }

  cancelReq() {
    this.loader = true;
    this.confirm = false;
    var post = {
      "endDate": this.returnDate(this.enddate),
      "cancellationReasons": this.cancellation
    }
    this.service.cancelPackageReq(this.cancelId, post).subscribe((res: any) => {

      this.handler.res("Subscription Cancelled successfully");
      this.ionViewWillEnter();
    })
  }


  refreshData(event) {
    this.ionViewWillEnter();
    setTimeout(() => {
      event.target.complete();
    }, 1000);
  }

  pay(id, id1, data) {
    this.router.navigate(['/review-invoice-subs/' + id]);
    sessionStorage.setItem('serviceId', id1)
    sessionStorage.setItem('month', data.month)
    sessionStorage.setItem('year', data.year)
    sessionStorage.setItem('status', data.paymentStatus)

  }

  notify() {
    // this.send = true;
    // this.check = true;
    this.items.map(res =>
      res.clicked = false)

    if (!this.send) {
      this.send = true;
    } else {
      this.send = false;
    }

    if (!this.check) {
      this.check = true;
    } else {
      this.check = false;
    }
  }


  triggerChange(data) {
    if (this.send) {
      data.clicked = !data.clicked
      if (data.clicked) {
        this.notifyItems.push(data);
      } else {
        this.notifyItems = this.notifyItems.filter(res => res.id != data.id)
      }
      // this.notifyItems = this.items.filter(res => res.clicked)

      this.notifyItems.map(res => {
        if (res.status == 4) {
          Object.assign(res, { statusInd: false })
        } else {
          Object.assign(res, { statusInd: true })
        }
      })
    }

  }

  sendNot() {
    this.notifyItems.map(res => {
      this.loader = true;
      var post = {
        "packNotifications": this.message
      }
      this.service.sendNotification(res.id, post).subscribe((res1: any) => {
        res.clicked = false;
        this.openPopUp = false;
        this.send = false;
        this.loader = false;
        this.check = false;
      }, err => {
        res.clicked = false;
        this.openPopUp = false;
        this.handler.err(err)
        this.send = false;
        this.loader = false;
        this.check = false;
      })
    })
  }

  sendReq() {
    this.notifyItems = this.notifyItems.filter(res => { return res.statusInd == true });
    if (this.notifyItems.length > 0) {
      sessionStorage.setItem('notify', JSON.stringify(this.notifyItems))
      this.send = false;
      this.check = false;
      this.router.navigate(['/group-On-Demand'])
    } else {
      this.handler.res("Please Select Cards To Continue")
    }
  }


  custItems(id) {
    this.router.navigate(['custItem/', +id])
  }

  searchCust() {
    this.router.navigate(['/cust-item-subs/' + this.userData.userId]);
  }
  searchCust1() {
    this.handler.error("Customer is not register.Kindly register your Details");
    var num1 = /^[0-9]+$/
    if (this.custName.match(num1)) {
      sessionStorage.setItem('mobile#', this.custName);
      this.router.navigate(['/newCustomer'])
    } else {
      sessionStorage.setItem('firstName', this.custName);
      this.router.navigate(['/newCustomer'])
    }
  }



  createNew() {
    this.router.navigate(['/newCustomer'])
    this.customerPopSearch = false;
  }

  customerDetail(id) {
    this.router.navigate(['cust-item-subs/' + id]);
    this.customerPopSearch = false;
  }

  close() {
    this.customerPop = false;
    this.numb = "";
  }

  close1() {
    this.customerPopSearch = false;
  }
  close2() {
    this.Paymentpop = false;
  }


  ionViewWillLeave() {
    this.numb = "";
    this.customerPop = false;
    this.nameCheck = false;
    this.search = "";
    this.custName = "";
    this.cloneUsers = "";
    this.userCheck = false;
  }

  Allocations(data, id) {
    if (data.status != 4) {
      if (data.status == 1 && this.auth.checkCapability('FSA')) {
        this.allocationOptions = [{ id: 0, name: "Assign Vendor" }, { id: 4, name: "Payment Activity" }]
      }

      if (data.status == 9 && this.auth.checkCapability('FSA')) {
        this.allocationOptions = [{ id: 1, name: "Assign Employee" }, { id: 2, name: "Change Vendor" }, { id: 4, name: "Payment Activity" }]
      }
      if (data.status == 6 && this.auth.checkCapability('FSA')) {
        this.allocationOptions = [{ id: 2, name: "Change Vendor" }, { id: 3, name: "Change Allocation" }, { id: 4, name: "Payment Activity" }]
      }
      if (data.status == 6 && !this.auth.checkCapability('FSA') && this.auth.checkCapability('SP')) {
        this.allocationOptions = [{ id: 3, name: "Change Allocation" }]
      }
      if (data.status == 9 && !this.auth.checkCapability('FSA') && this.auth.checkCapability('SP')) {
        this.allocationOptions = [{ id: 1, name: "Assign Employee" }]
      }

      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data: this.allocationOptions,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        if (res) {
          this.optionName = res.name;
          this.optionId = res.id;
          if (this.optionId == 0) {
            this.Vendorselect1(data, id);
          }
          if (this.optionId == 2) {
            this.changeVendorselect1(data, id);
          }
          if (this.optionId == 1) {
            this.assignVendor(data, id);
          }
          if (this.optionId == 3) {
            this.assignVendor(data, id);
          }
          if (this.optionId == 4) {
            this.getPaymentsDetail(id);
          }

        }
      });
    } else {
      this.handler.res("No Actions Found")
    }
  }


  ngDoCheck(): void {
    this.filterLength = sessionStorage.getItem('len')
  }


  filterReq() {
    this.filterPop = true;
  }

  getsc1() {
    // this.loader = true;
    this.service.getUsersByOrg('SC', this.id, null).subscribe((res: any) => {
      this.contractors = res;
      this.contractors = this.contractors.filter(res => { return res.reqRoleApproved == true });
      // this.loader = false;
    }, err => {
      this.handler.err(err)
    })
  }

  getsc() {
    this.loader = true;
    this.filterPop = false;
    this.service.getUsersByOrg('SC', this.orgId, null).subscribe((res: any) => {
      if (res) {
        this.contractors = res;
        this.contractors.map(res => {
          if (res.categoryLists)
            res.categoryLists.map(res1 => {
              if (res1.categoryId == this.cateId) {
                this.cate1Id = res1.categoryId
                Object.assign(res, { vId: this.cate1Id })
              }
            })
        })
        this.contractors = this.contractors.filter(res => { return res.reqRoleApproved == true && res.vId == this.cateId });
        this.loader = false;
        this.filterPop = true;
      } else {
        this.loader = false;
        this.contractors = [];
        this.filterPop = true;
        this.handler.res("NO DATA FOUND");
      }
    }, err => {
      this.loader = false;
      this.handler.err(err)
    })
  }

  openBottomSheetCon(): void {
    if (!this.active1) {
      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data: this.contractors,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        this.statusName = ""
        this.contractorId = res.userId;
        if (res.lastName)
          this.ContractorName = res.firstName;
        else
          this.ContractorName = res.firstName;
      });
    }
  }

  openBottomSheetCon1(): void {
    if (!this.active1) {
      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data: this.contractors,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        this.statusName = ""
        this.contractorId = res.userId;
        if (res.lastName)
          this.ContractorName = res.firstName;
        else
          this.ContractorName = res.firstName;
      });
    }
  }

  cancelFilter() {
    this.loader = true;
    this.statusName = "";
    this.statusId = undefined;
    this.contractorId = undefined;
    this.ContractorName = "";
    this.paymentName = "";
    this.paymentId = undefined;
    this.orgName = "";
    this.orgId = undefined;
    this.cateId = "";
    this.filterPop = false;
    this.filter = false;
    this.ionViewWillEnter();
  }

  getMonthName(id) {
    this.monthObj.map(res => {
      if (id == res.id) {
        return res.name
      }
    })

  }

  getPaymentsDetail(id) {
    this.service.getPaymentActivity(id).subscribe((res: any) => {
      this.paymentActivity = res;

      this.paymentActivity.paymentDetails.map(dat => {
        if (dat) {
          this.monthObj.map(dat1 => {
            if (dat.month == dat1.id) {
              Object.assign(dat, { monthName: dat1.name })
            }
          })
        }
      })
      setTimeout(() => {
        this.Paymentpop = true;
      }, 500);


    })
  }

  getUser(val) {
    let x = val.length;
    if (x > 0) {
      this.service.searchCustomers("CUST", val, this.id).subscribe((res: any) => {
        if (res != null && res != "NO_CONTENT" && res.length > 0) {
          this.cloneUsers = JSON.parse(JSON.stringify(res));
          if (!this.custName) {
            this.cloneUsers = [];
          }
        } else {
          this.cloneUsers = [];
        }
      })
    } else {
      this.cloneUsers = [];
    }
  }

  getCusData(data) {
    this.userData = data;
    this.userCheck = true;
  }


  openBottomSheetAction() {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.actionObj,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.actionName = res.name;
      this.actionId = res.id;
      if (this.actionId == 1) {
        this.service.getPaymentRemainderMsgSubs().subscribe((res: any) => {
          this.message = res.packNotifications;
        })
        this.openPopUp = true;
      }
      if (this.actionId == 0) {
        this.sendReq();
      }
    });


  }

  clear() {
    this.search = "";
    this.closeing = false;
    this.items = this.filterItems;
    this.getCount();
    // this.ionViewWillEnter();

  }


  subscritionByPage($event) {
    if (!this.filter) {
      this.clear();
      if (this.id == 790) {
        this.service.getCustItemSubsCate(this.cateId, k).subscribe((res: any) => {

          res.map(dat => {
            this.items.push(dat);
          })
          this.items.map(res1 => {
            Object.assign(res1, { clicked: false, bikeNumber: res1.custItems[0]?.identificationNo })
          })
          this.items.map(dat => {
            if (dat.paymentDetails) {
              dat.paymentDetails.map(dat1 => {
                this.monthObj.map(dat2 => {
                  if (dat1.month == dat2.id) {
                    Object.assign(dat1, { monthName: dat2.name })
                  }
                })
              })
            }
          })
          this.filterItems = this.items;
          this.loader = false;
          k++;
        }, err => {
          this.loader = false;
        })
      } else {
        this.service.getVenCustItemSubsCate(this.id, this.cateId, k).subscribe((res: any) => {
          res.map(dat => {
            this.items.push(dat);
          })
          this.items.map(res1 => {
            Object.assign(res1, { clicked: false, bikeNumber: res1.custItems[0]?.identificationNo })
          })
          this.items.map(dat => {
            if (dat.paymentDetails) {
              dat.paymentDetails.map(dat1 => {
                this.monthObj.map(dat2 => {
                  if (dat1.month == dat2.id) {
                    Object.assign(dat1, { monthName: dat2.name })
                  }
                })
              })
            }
          })
          this.filterItems = this.items;
          this.loader = false;
          k++;
        }, err => {
          this.loader = false;
        })
      }
    }

  }

  searchfilter1() {
    this.filterPop = false;
    this.filter = true;
    var post = [{ id: 1, val: this.cateId, cateId: true, data: "categoryId" },
    { id: 2, val: this.orgId, orgId: true, data: "vendorId" },
    { id: 3, val: this.contractorId, contractorId: true, data: "serviceContractorId" },
    { id: 4, val: this.statusId, statusId: true, data: "status" },
    { id: 5, val: this.paymentId, paymentId: true, data: "paymentStatus" }]
    var y = post.filter(res => { return res.val != undefined })
    if (y.length == 1) {
      this.loader = true;
      this.service.getCustomerItemSubsCate1(y[0].data, y[0].val).subscribe((res: any) => {
        if (res) {
          this.items = res;
          this.items.map(res1 => {
            Object.assign(res1, { clicked: false, bikeNumber: res1.custItems[0]?.identificationNo })
          })
          this.items.map(dat => {
            if (dat.paymentDetails) {
              dat.paymentDetails.map(dat1 => {
                this.monthObj.map(dat2 => {
                  if (dat1.month == dat2.id) {
                    Object.assign(dat1, { monthName: dat2.name })
                  }
                })
              })
            }
          })
          this.count = this.items.length;
          this.loader = false;
        } else {
          this.loader = false;
          this.items = [];
          this.count = 0;
          this.handler.res("No Data Found");
        }
      }, err => {
        this.loader = false;
        this.filterPop = true;
        this.handler.err(err);
      })
    }
    if (y.length == 2) {
      this.loader = true;
      this.service.getCustomerItemSubsCate2(y[0].data, y[1].data, y[0].val, y[1].val).subscribe((res: any) => {
        if (res) {
          this.items = res;
          this.items.map(res1 => {
            Object.assign(res1, { clicked: false, bikeNumber: res1.custItems[0]?.identificationNo })
          })
          this.items.map(dat => {
            if (dat.paymentDetails) {
              dat.paymentDetails.map(dat1 => {
                this.monthObj.map(dat2 => {
                  if (dat1.month == dat2.id) {
                    Object.assign(dat1, { monthName: dat2.name })
                  }
                })
              })
            }
          })
          this.count = this.items.length;
          this.loader = false;
        }
        else {
          this.loader = false;
          this.items = [];
          this.count = 0;
          this.handler.res("No Data Found");
        }
      }, err => {
        this.loader = false;
        this.filterPop = true;
        this.handler.err(err);
      })
    }
    if (y.length == 3) {
      this.loader = true;
      this.service.getCustomerItemSubsCate3(y[0].data, y[1].data, y[2].data, y[0].val, y[1].val, y[2].val).subscribe((res: any) => {
        if (res) {
          this.items = res;
          this.items.map(res1 => {
            Object.assign(res1, { clicked: false, bikeNumber: res1.custItems[0]?.identificationNo })
          })
          this.items.map(dat => {
            if (dat.paymentDetails) {
              dat.paymentDetails.map(dat1 => {
                this.monthObj.map(dat2 => {
                  if (dat1.month == dat2.id) {
                    Object.assign(dat1, { monthName: dat2.name })
                  }
                })
              })
            }
          })
          this.count = this.items.length;
          this.loader = false;
        } else {
          this.loader = false;
          this.items = [];
          this.count = 0;
          this.handler.res("No Data Found");
        }
      }, err => {
        this.loader = false;
        this.filterPop = true;
        this.handler.err(err);
      })
    }
    if (y.length == 4) {
      this.loader = true;
      this.service.getCustomerItemSubsCate4(y[0].data, y[1].data, y[2].data, y[3].data, y[0].val, y[1].val, y[2].val, y[3].val).subscribe((res: any) => {
        if (res) {
          this.items = res;
          this.items.map(res1 => {
            Object.assign(res1, { clicked: false, bikeNumber: res1.custItems[0]?.identificationNo })
          })
          this.items.map(dat => {
            if (dat.paymentDetails) {
              dat.paymentDetails.map(dat1 => {
                this.monthObj.map(dat2 => {
                  if (dat1.month == dat2.id) {
                    Object.assign(dat1, { monthName: dat2.name })
                  }
                })
              })
            }
          })
          this.count = this.items.length;
          this.loader = false;
        } else {
          this.loader = false;
          this.items = [];
          this.count = 0;
          this.handler.res("No Data Found");
        }
      }, err => {
        this.loader = false;
        this.filterPop = true;
        this.handler.err(err);
      })
    }
    if (y.length == 5) {
      this.loader = true;
      this.service.getCustomerItemSubsCate5(y[0].data, y[1].data, y[2].data, y[3].data, y[4].data, y[0].val, y[1].val, y[2].val, y[3].val, y[4].val).subscribe((res: any) => {
        if (res) {
          this.items = res;
          this.items.map(res1 => {
            Object.assign(res1, { clicked: false, bikeNumber: res1.custItems[0]?.identificationNo })
          })
          this.items.map(dat => {
            if (dat.paymentDetails) {
              dat.paymentDetails.map(dat1 => {
                this.monthObj.map(dat2 => {
                  if (dat1.month == dat2.id) {
                    Object.assign(dat1, { monthName: dat2.name })
                  }
                })
              })
            }
          })
          this.count = this.items.length;
          this.loader = false;
        } else {
          this.loader = false;
          this.items = [];
          this.count = 0;
          this.handler.res("No Data Found");
        }
      }, err => {
        this.loader = false;
        this.filterPop = true;
        this.handler.err(err);
      })
    }

  }
  getCancelReason() {
    this.service.getcancellationReason().subscribe(res => {
      this.cancelledReasons = res;

    })
  }

  clearArray2(value) {
    this.cancellation = value.name;
  }

  viewChange(id) {
    if (id == 1) {
      this.Cview = true;
      this.searchShow = true;
      this.ionViewWillEnter();
    }
    else {
      this.Cview = false;
      this.searchShow = false;
      this.matTableData();
    }
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return data.id.toString().toLowerCase().indexOf(searchTerms.id) !== -1
        && data.bikeNumber.toString().toLowerCase().indexOf(searchTerms.bikeNumber) !== -1
        && data.custName.toString().toLowerCase().indexOf(searchTerms.custName) !== -1
        && data.carmake.toString().toLowerCase().indexOf(searchTerms.carmake) !== -1
        && data.carmodel.toString().toLowerCase().indexOf(searchTerms.carmodel) !== -1
        && data.serviceName.toString().toLowerCase().indexOf(searchTerms.serviceName) !== -1
        && data.regionId.toString().toLowerCase().indexOf(searchTerms.regionId) !== -1
        && data.serviceFlat.toString().toLowerCase().indexOf(searchTerms.serviceFlat) !== -1
        // && data.payStatusName1.toString().toLowerCase().indexOf(searchTerms.payStatusName1) !== -1
        // && data.payStatusName2.toString().toLowerCase().indexOf(searchTerms.payStatusName2) !== -1
        // && data.payStatusName3.toString().toLowerCase().indexOf(searchTerms.payStatusName3) !== -1
        && data.reqStatusName.toString().toLowerCase().indexOf(searchTerms.reqStatusName) !== -1
    }
    return filterFunction;
  }

  matTableData() {
    this.loader = true;
    this.getCount();
    if (this.id == 790) {
      this.cateId = 21;
      this.service.getCustItemSubsCateMatTable(this.cateId).subscribe((res: any) => {

        if (res) {
          this.items = res;

          this.items.map(res => {
            Object.assign(res, { clicked: false })
          })
          this.items.map(dat => {
            if (dat.paymentDetails) {
              dat.paymentDetails.map(dat1 => {
                this.monthObj.map(dat2 => {
                  if (dat1.month == dat2.id) {
                    Object.assign(dat1, { monthName: dat2.name })
                  }
                })
              })
            }
          })
          this.items.map(res1 => {
            if (res1.custItems)
              Object.assign(res1, { bikeNumber: res1.custItems[0]?.identificationNo, carmake: res1.custItems[0]?.make, carmodel: res1.custItems[0]?.model })
            if (res1.services)
              Object.assign(res1, { serviceName: res1.services[0]?.name })
            if (res1.appt == true)
              Object.assign(res1, { serviceFlat: res1.flatName })
            if (res1.appt == false)
              Object.assign(res1, { serviceFlat: res1.street })
            if (res1.appt == "" || res1.appt == undefined)
              Object.assign(res1, { serviceFlat: "Not Specified" })
            if (res1.status == 1)
              Object.assign(res1, { reqStatusName: "Pending" })
            if (res1.status == 2)
              Object.assign(res1, { reqStatusName: "Confirmed" })
            if (res1.status == 3)
              Object.assign(res1, { reqStatusName: "Completed" })
            if (res1.status == 4)
              Object.assign(res1, { reqStatusName: "Cancelled" })
            if (res1.status == 6)
              Object.assign(res1, { reqStatusName: "Allocated" })
            if (res1.status == 7)
              Object.assign(res1, { reqStatusName: "Missed" })
            if (res1.status == 8)
              Object.assign(res1, { reqStatusName: "Not In Place" })
            if (res1.status == 9)
              Object.assign(res1, { reqStatusName: "Assigned" })
            if (res1.paymentDetails)
              Object.assign(res1, {
                PayMonth1: res1.paymentDetails[0]?.monthName,
                PayMonth2: res1.paymentDetails[1]?.monthName,
                PayMonth3: res1.paymentDetails[2]?.monthName,
              })
            if (res1.paymentDetails[0]?.paymentStatus == 1)
              Object.assign(res1, { payStatusName1: "Not Paid" })
            if (res1.paymentDetails[0]?.paymentStatus == 2)
              Object.assign(res1, { payStatusName1: "Paid" })
            if (res1.paymentDetails[1]?.paymentStatus == 1)
              Object.assign(res1, { payStatusName2: "Not Paid" })
            if (res1.paymentDetails[1]?.paymentStatus == 2)
              Object.assign(res1, { payStatusName2: "Paid" })
            if (res1.paymentDetails[2]?.paymentStatus == 1)
              Object.assign(res1, { payStatusName3: "Not Paid" })
            if (res1.paymentDetails[2]?.paymentStatus == 2)
              Object.assign(res1, { payStatusName3: "Paid" })
            if (res1.PayMonth1 == undefined)
              Object.assign(res1, { payStatusName1: "-" })
            if (res1.PayMonth2 == undefined)
              Object.assign(res1, { payStatusName2: "-" })
            if (res1.PayMonth3 == undefined)
              Object.assign(res1, { payStatusName3: "-" })
          })

          this.dataSource = new MatTableDataSource(this.items);
          this.dataSource.sort = this.sort;
          this.dataSource.filterPredicate = this.createFilter();
          this.loader = false;
        } else {
          this.dataSource = [];
          this.items = [];
          this.handler.res("No Data Found");
          this.loader = false;
        }
      }, err => {
        this.loader = false;
        this.handler.err(err);
      })
    } else {
      this.cateId = 21;
      this.service.getVenCustItemSubsCateMatTable(this.id, this.cateId).subscribe((res: any) => {
        if (res) {
          this.items = res;
          this.items.map(dat => {
            if (dat.paymentDetails) {
              dat.paymentDetails.map(dat1 => {
                this.monthObj.map(dat2 => {
                  if (dat1.month == dat2.id) {
                    Object.assign(dat1, { monthName: dat2.name })
                  }
                })
              })
            }
          })
          this.items.map(res1 => {
            if (res1.custItems)
              Object.assign(res1, { bikeNumber: res1.custItems[0]?.identificationNo, carmake: res1.custItems[0]?.make, carmodel: res1.custItems[0]?.model })

            if (res1.services)
              Object.assign(res1, { serviceName: res1.services[0]?.name })
            if (res1.appt == true)
              Object.assign(res1, { serviceFlat: res1.flatName })
            if (res1.appt == false)
              Object.assign(res1, { serviceFlat: res1.street })
            if (res1.appt == "" || res1.appt == undefined)
              Object.assign(res1, { serviceFlat: "Not Specified" })
            if (res1.status == 1)
              Object.assign(res1, { reqStatusName: "Pending" })
            if (res1.status == 2)
              Object.assign(res1, { reqStatusName: "Confirmed" })
            if (res1.status == 3)
              Object.assign(res1, { reqStatusName: "Completed" })
            if (res1.status == 4)
              Object.assign(res1, { reqStatusName: "Cancelled" })
            if (res1.status == 6)
              Object.assign(res1, { reqStatusName: "Allocated" })
            if (res1.status == 7)
              Object.assign(res1, { reqStatusName: "Missed" })
            if (res1.status == 8)
              Object.assign(res1, { reqStatusName: "Not In Place" })
            if (res1.status == 9)
              Object.assign(res1, { reqStatusName: "Assigned" })
            if (res1.paymentDetails)
              Object.assign(res1, {
                PayMonth1: res1.paymentDetails[0]?.monthName,
                PayMonth2: res1.paymentDetails[1]?.monthName,
                PayMonth3: res1.paymentDetails[2]?.monthName,
              })
            if (res1.paymentDetails[0]?.paymentStatus == 1)
              Object.assign(res1, { payStatusName1: "Not Paid" })
            if (res1.paymentDetails[0]?.paymentStatus == 2)
              Object.assign(res1, { payStatusName1: "Paid" })
            if (res1.paymentDetails[1]?.paymentStatus == 1)
              Object.assign(res1, { payStatusName2: "Not Paid" })
            if (res1.paymentDetails[1]?.paymentStatus == 2)
              Object.assign(res1, { payStatusName2: "Paid" })
            if (res1.paymentDetails[2]?.paymentStatus == 1)
              Object.assign(res1, { payStatusName3: "Not Paid" })
            if (res1.paymentDetails[2]?.paymentStatus == 2)
              Object.assign(res1, { payStatusName3: "Paid" })
            if (res1.PayMonth1 == undefined)
              Object.assign(res1, { payStatusName1: "-" })
            if (res1.PayMonth2 == undefined)
              Object.assign(res1, { payStatusName2: "-" })
            if (res1.PayMonth3 == undefined)
              Object.assign(res1, { payStatusName3: "-" })
          })
          this.dataSource = new MatTableDataSource(this.items);
          this.dataSource.filterPredicate = this.createFilter();
          this.dataSource.sort = this.sort;
          this.loader = false;
        } else {
          this.dataSource = [];
          this.items = [];
          this.handler.res("No Data Found");
          this.loader = false;
        }
      }, err => {
        this.loader = false;
        this.handler.err(err);

      })
    }
  }
  exportAsXLSX() {
    this.items.map(res => {
      res.custItems.map(dat => {
        Object.assign(res, { VechicleNo: dat.identificationNo, Make: dat.make, Model: dat.model, Colour: dat.colour })
      })
      res.services.map(ser => {
        Object.assign(res, { packName: ser.name })
      })
      if (res.paymentDetails)
        Object.assign(res, {
          PayMonth1: res.paymentDetails[0]?.monthName,
          PayMonth2: res.paymentDetails[1]?.monthName,
          PayMonth3: res.paymentDetails[2]?.monthName,
        })
      if (res.paymentDetails[0]?.paymentStatus == 1)
        Object.assign(res, { payStatusName1: "Not Paid" })
      if (res.paymentDetails[0]?.paymentStatus == 2)
        Object.assign(res, { payStatusName1: "Paid" })
      if (res.paymentDetails[1]?.paymentStatus == 1)
        Object.assign(res, { payStatusName2: "Not Paid" })
      if (res.paymentDetails[1]?.paymentStatus == 2)
        Object.assign(res, { payStatusName2: "Paid" })
      if (res.paymentDetails[2]?.paymentStatus == 1)
        Object.assign(res, { payStatusName3: "Not Paid" })
      if (res.paymentDetails[2]?.paymentStatus == 2)
        Object.assign(res, { payStatusName3: "Paid" })
      if (res.PayMonth1 == undefined)
        Object.assign(res, { payStatusName1: "-" })
      if (res.PayMonth2 == undefined)
        Object.assign(res, { payStatusName2: "-" })
      if (res.PayMonth3 == undefined)
        Object.assign(res, { payStatusName3: "-" })



      this.excelDataAll.push({
        SubscriptionId: res.id, IdentificationNo: res.VechicleNo, CustomerName: res.custName, Make: res.Make, Model: res.Model, Colour: res.Colour,
        Services: res.packName, Month1: res.PayMonth1, Status1: res.payStatusName1, Month2: res.PayMonth2, Status2: res.payStatusName2, Month3: res.PayMonth3, Status3: res.payStatusName3
      })
    })
    this.excelService.exportAsExcelFile(this.excelDataAll, 'Subscription Details');


    this.excelDataAll = []
  }


}